import React from 'react';
import type { ProjectMiniRailProps } from '../projects.types';
import './ProjectMiniRail.styles.css';

/**
 * Vertical left-side rail displaying shrunken cards during desktop expansion.
 * Enables quick one-click switching between active project details.
 */
export const ProjectMiniRail: React.FC<ProjectMiniRailProps> = ({
  projects,
  activeProjectId,
  onSelect,
}) => {
  return (
    <aside className="mini-rail-container" aria-label="Sibling Projects Quick Switcher">
      {projects.map((project) => {
        const isActive = project.id === activeProjectId;
        return (
          <div
            key={project.id}
            role="button"
            tabIndex={0}
            className={`mini-rail-card ${isActive ? 'active' : ''}`}
            onClick={() => onSelect(project)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(project);
              }
            }}
            aria-selected={isActive}
            aria-label={`View ${project.title}`}
          >
            <span className="mini-card-category">{project.category}</span>
            <span className="mini-card-title">{project.title}</span>
            {project.role && <span className="mini-card-role">{project.role}</span>}
          </div>
        );
      })}
    </aside>
  );
};

export default ProjectMiniRail;
